import React from "react";
import MenuNavLink from "../components/UI/NavLink";
import { useTranslation } from "react-i18next";

export function getMenuByRole(role, t) {

    const isAdmin = role === "Админ";
    const isManager = role === "Менеджер";
    const isWorker = role === "Warehouse";
    const isKRSclad = role === "Работник основного склада";
    const isIssue = role === "Работник выдачи";
    const isDelivery = role === "Работник доставки";

    const menu = [];
    if (isAdmin) {
        menu.push(
            {
                label: t('menu.employees'),
                icon: 'pi pi-id-card',
                template: () => <MenuNavLink label={t('menu.employees')} icon="pi pi-id-card" link="/employee" />
            },
            {
                label: t('menu.balance'),
                icon: 'pi pi-wallet',
                template: () => <MenuNavLink label={t('menu.balance')} icon="pi pi-wallet" link="/bonus" />
            }, {
            label: t('menu.actions'),
            icon: 'pi pi-play',
            template: () => <MenuNavLink label={t('menu.actions')} icon="pi pi-play" link="/actions" />
        },
            {
                label: t('menu.tarif'),
                icon: 'pi pi-users',
                template: () => <MenuNavLink label={t('menu.tarif')} icon="pi pi-users" link="/tarif" />
            },
        )
    }

    if (isAdmin || isManager) {
        menu.push(
            {
                label: t('menu.users'),
                icon: 'pi pi-user',
                template: () => <MenuNavLink label={t('menu.users')} icon="pi pi-user" link="/users" />
            },
            {
                label: t('menu.stores'),
                icon: 'pi pi-shopping-bag',
                template: () => <MenuNavLink label={t('menu.stores')} icon="pi pi-shopping-bag" link="/store" />
            },
            {
                label: t('menu.directory'),
                icon: 'pi pi-shopping-bag',
                template: () => <MenuNavLink label={t('menu.directory')} icon="pi pi-shopping-bag" link="/directory" />
            },
            {
                label: t('Загрузка с excel'),
                icon: 'pi pi-truck',
                template: () => <MenuNavLink label={t('Отправка рассылки с excel')} icon="pi pi-truck" link="/upload-user" />
            },
            {
                label: t('menu.buyforme'),
                icon: 'pi pi-table',
                template: () => <MenuNavLink label={t('menu.buyforme')} icon="pi pi-table" link="/buyforme" />
            }, {
            label: t('Выданные заказы'),
            icon: 'pi pi-table',
            template: () => <MenuNavLink label={t('Выданные заказы')} icon="pi pi-table" link="/order/30" />
        }

        );
    }

    if (isAdmin || isManager || isWorker) {
        menu.push(
            {
                label: t('menu.scan'),
                icon: 'pi pi-qrcode',
                template: () => <MenuNavLink label={t('menu.scan')} icon="pi pi-qrcode" link="/rscan" />
            },
            {
                label: t('menu.ordersPending'),
                icon: 'pi pi-list',
                template: () => <MenuNavLink label={t('menu.ordersPending')} icon="pi pi-list" link="/order/0" />
            },
            {
                label: t('menu.ordersProc'),
                icon: 'pi pi-list',
                template: () => <MenuNavLink label={t('menu.ordersProc')} icon="pi pi-list" link="/order-process/25" />
            },
            {
                label: t('menu.ordersWarehouse'),
                icon: 'pi pi-inbox',
                template: () => <MenuNavLink label={t('menu.ordersWarehouse')} icon="pi pi-inbox" link="/order/15" />
            },
            {
                label: t('menu.boxes'),
                icon: 'pi pi-briefcase',
                template: () => <MenuNavLink label={t('menu.boxes')} icon="pi pi-briefcase" link="/box" />
            },
            {
                label: t('menu.batchesWarehouse'),
                icon: 'pi pi-table',
                template: () => <MenuNavLink label={t('menu.batchesWarehouse')} icon="pi pi-table" link="/partial/0" />
            },

            {
                label: t('menu.ordersTransit'),
                icon: 'pi pi-truck',
                template: () => <MenuNavLink label={t('menu.ordersTransit')} icon="pi pi-truck" link="/order/16" />
            }, {
            label: t('Получатели'),
            icon: 'pi pi-table',
            template: () => <MenuNavLink label={t('Получатели')} icon="pi pi-table" link="/recievers" />
        }
        );
    }

    if (isDelivery) {
        menu.push(
            {
                label: t('Доставка'),
                icon: 'pi pi-user',
                template: () => <MenuNavLink label={t('Доставка')} icon="pi pi-user" link="delivery" />
            }, {
            label: t('Прием на доставку'),
            icon: 'pi pi-user',
            template: () => <MenuNavLink label={t('Прием на доставку')} icon="pi pi-user" link="accept-delivery" />
        }
        );
    }

    if (isKRSclad || isAdmin || isManager) {
        menu.push(
            {
                label: t('Партия на ОСН складе'),
                icon: 'pi pi-check-square',
                template: () => <MenuNavLink label={t('Партия на ОСН складе')} icon="pi pi-check-square" link="/partial/18" />
            },
            {
                label: t('Прием заказов на ОСН склад'),
                icon: 'pi pi-check-square',
                template: () => <MenuNavLink label={t('Прием заказов на ОСН склад')} icon="pi pi-check-square" link="/order-sort" />
            },
            {
                label: t('menu.ordersTransit'),
                icon: 'pi pi-truck',
                template: () => <MenuNavLink label={t('Заказы на складе')} icon="pi pi-truck" link="/order/18" />
            },
            // {
            //     label: t('menu.batchesToIssue'),
            //     icon: 'pi pi-check-square',
            //     template: () => <MenuNavLink label={t('menu.batchesToIssue')} icon="pi pi-check-square" link="/qr-scanner" />
            // }
        );


        if (isAdmin || isManager || isWorker || isKRSclad || isIssue) {
            menu.push({
                label: t('menu.batchesArrived'),
                icon: 'pi pi-check-square',
                template: () => <MenuNavLink label={t('menu.batchesArrived')} icon="pi pi-check-square" link="/partial/16" />
            }
            )
        }
    }
    if (isAdmin || isManager || isIssue) {
        menu.push(
            {
                label: t('menu.issue'),
                icon: 'pi pi-list',
                template: () => <MenuNavLink label={t('menu.issue')} icon="pi pi-list" link="/issue" />
            },
            {
                label: t('Прием заказов на ПВЗ'),
                icon: 'pi pi-list',
                template: () => <MenuNavLink label={t('Прием заказов на ПВЗ')} icon="pi pi-list" link="/scan-receive" />
            }
        )


    }

    return menu;
}


